export default "__VITE_ASSET__$md53x4S__"